import * as frames from './frames';
import PanelCloseOrigin from './frames/panelCloseOrigin';
import * as mixins from './mixins/mixins';
import * as helpPanels from './helpPanels/helpPanels';
import * as errorPages from './errorPages/errorPagesPanels';
import * as focusPanels from './focusPanels/focusPanels';
import * as widgetPanels from './widgetPanels/widgetPanels';
import * as promotionalPanels from './promotionalPanels/promotionalPanels';
import type { LinkPanelComponentOwnProps } from './toolPanels/linkPanel/LinkPanel';
import * as messagePanels from './messagePanels/messagePanels';
import * as definitions from './panelsDefinitions/panelsDefinitions';
import toolPanels, {
  type IMultiselectPanelItem,
  type IMultiselectPanelSection,
  type IMultiselectPanelGroup,
  type IMultiselectPanelOwnProps,
  type IReplaceRemovePanelProps,
} from './toolPanels/toolPanels';
import linkTo from './commonControls/linkTo/linkTo';
import linkToButton from './commonControls/linkTo/linkToButton';
import linkToMixin from './commonControls/linkTo/linkToMixin';
import OpenedRightPanels from './rightPanels/openedRightPanels/openedRightPanels';
import {
  getBusinessTypeByString,
  suggestItemsToOptions,
  useInputWithInputSuggestions,
} from './focusPanels/changeBusinessTypePanel/withSuggestions';
import type * as ColorPickerTypes from './toolPanels/colorPicker/colorPickerPanelWithGradient/types';
import type * as BusinessTypeTypes from './focusPanels/changeBusinessTypePanel/types';
import { PAGES_TO_BLOCK_IN_LINK_PANEL } from './toolPanels/linkPanel/constants';
import { getAppPagesSections } from './toolPanels/linkPanel/utils';
import type { PageCategoryWithSubPages } from './toolPanels/linkPanel/utils';
import { pageIsInLinkPanelBlackList } from './toolPanels/linkPanel/utils';

const commonControls = {
  linkTo,
  linkToButton,
};
import type { AnchorData } from './toolPanels/linkPanel/components/AnchorLink/AnchorLink.mapper';
import { getMainPagesIds } from './toolPanels/linkPanel/utils';

const businessTypeUtils = {
  getBusinessTypeByString,
  suggestItemsToOptions,
  useInputWithInputSuggestions,
};

export {
  definitions,
  frames,
  PanelCloseOrigin,
  mixins,
  helpPanels,
  errorPages,
  focusPanels,
  promotionalPanels,
  messagePanels,
  toolPanels,
  commonControls,
  linkToMixin,
  OpenedRightPanels,
  widgetPanels,
  businessTypeUtils,
  getMainPagesIds,
  PAGES_TO_BLOCK_IN_LINK_PANEL,
  getAppPagesSections,
  pageIsInLinkPanelBlackList,
};

export type {
  IMultiselectPanelItem,
  IMultiselectPanelSection,
  IMultiselectPanelGroup,
  IMultiselectPanelOwnProps,
  LinkPanelComponentOwnProps,
  ColorPickerTypes,
  IReplaceRemovePanelProps,
  BusinessTypeTypes,
  AnchorData,
  PageCategoryWithSubPages,
};
